import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { USAEPayPatientPaymentForm } from "@/routes/_private/_patient-360/patient/$patientId/create/-patient-payment/usaepay-form";
import { useState } from "react";
import ConfirmModal from "@/components/modals/confirm-modal";
import { useCheckPatientPaymentLink } from "@/requests/gen/react-query/patient-payment-link";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute(
  "/_public/patient-payment-link/$patientPaymentLinkId",
)({
  component: PatientPaymentLinkPage,
});

function PatientPaymentLinkPage() {
  const { patientPaymentLinkId } = Route.useParams();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const checkLink = useCheckPatientPaymentLink(patientPaymentLinkId);

  return (
    <div>
      <title>Payment Link - Legrande Health Portal</title>
      {/* Success Modal */}
      <ConfirmModal
        isOpen={isSuccessModalOpen}
        text="Payment information successfully added!"
        title="Success!"
        onCancel={() => {
          setIsSuccessModalOpen(false);
        }}
        onConfirm={() => {}}
        img="success"
        cancelText="Done"
      />

      <Card>
        <CardHeader>
          <CardTitle>{isSuccess ? "Success!" : "New Payment"}</CardTitle>
          <CardDescription>
            {isSuccess
              ? "You may now close this page."
              : "Enter your payment details below."}
          </CardDescription>
        </CardHeader>
        <CardContent className="md:min-w-2xl">
          {!isSuccess &&
            (checkLink.isPending ? (
              <div className="flex items-center gap-2 text-muted-foreground">
                <Loader2 className="size-4 animate-spin" />
                Loading...
              </div>
            ) : checkLink.isError ? (
              <div className="text-destructive text-sm">
                This payment link is invalid or has expired. Please contact your
                practice for assistance.
              </div>
            ) : (
              checkLink.data && (
                <USAEPayPatientPaymentForm
                  patientId={checkLink.data}
                  patientPaymentLinkId={patientPaymentLinkId}
                  onSuccessFn={() => {
                    setIsSuccessModalOpen(true);
                    setIsSuccess(true);
                  }}
                />
              )
            ))}
        </CardContent>
      </Card>
    </div>
  );
}
